import { useQuery } from "react-query";

import { getCompanies } from "../../../../../MyApi/hr/companies";

import LoadingSpinner from "../../../../UI/spinner";
import icons from "../../../../../Data/icons";

import classes from "./addCurrency.module.css";
import { useTranslation } from "react-i18next";

const AddSalary = ({
  amount,
  type,
  amount_Type,
  setSalaryName,
  setAmount,
  companyId,
  setCompanyId,
  setAmount_type,
  setDescription,
  description,
  setActive,
  active,
  setType,
  salaryName,
}) => {
  const { data, isLoading } = useQuery("getComapines", getCompanies);
  const {t} =useTranslation()
  const DescriptionIcon = icons.description;
  const LevelIcon = icons.levels;

  const DollarSign = icons.Dollar;
  const Company = icons.company;
  const AbcIcon = icons.abc
  const AmoutIcon = icons.amount
  const TypeIcon = icons.type

  const handleNameChange = (e) => {
    const { value } = e.target;
    setSalaryName(value);
  };
  const handleSelectedIdChange = (e) => {
    setCompanyId(e.target.options[e.target.selectedIndex].id);
  };
  const handleDescChange = (e) => {
    const { value } = e.target;
    setDescription(value);
  };
  const handleAmountChange = (e) => {
    const { value } = e.target;
    const doubleAmount = parseFloat(value).toFixed(3);
    setAmount(value);
  };
  const handleType = (e) => {
    const { value } = e.target;
    setType(value);
  };
  const handleAmountType = (e) => {
    const { value } = e.target;
    setAmount_type(value);
  };
  const handleActiveChange = (e) => {
    const isChecked = e.target.checked;
    setActive(isChecked ? 1 : 0);
  };

  if (isLoading) {
    return <LoadingSpinner />;
  }
  const comapines = data?.data || [];
  const amountType = ["percent", "fixed"];
  const typeArr = ["undeserved", "deserved"];
  return (
    <div className="row">
      <div className="col-lg-6">
        <div className={classes.formCard}>
          <div className={classes.formGrid}>
            <div className={classes.formCol}>
              <label htmlFor="">{t("Name")} </label>
              <div className={classes.iconInput}>
                <AbcIcon />
              </div>
              <input
                type="text"
                value={salaryName}
                placeholder="ادخل  الاسم"
                onChange={handleNameChange}
                className={classes.inputCustom}
              />
            </div>
            <div className={classes.formCol}>
              <label htmlFor="">{t("Description")} </label>
              <div className={classes.iconInput}>
                <DescriptionIcon />
              </div>
              <textarea
                type="textarea"
                placeholder={t("Enter Description")}
                onChange={handleDescChange}
                value={description}
                className={classes.inputCustom}>
                {" "}
              </textarea>
            </div> 
            <div className={classes.formCol}>
              <label htmlFor="">{t("Amount")} </label>
              <div className={classes.iconInput}>
                <AmoutIcon />
              </div>
              <input
                type="number"
                placeholder={t("Enter Amount")}
                onChange={handleAmountChange}
                value={amount}
                className={classes.inputCustom}
              />
            </div>
            <div className={classes.formCol}>
              <label htmlFor="">{t("Type")} </label>
              <div className={classes.iconInput}>
                <TypeIcon />
              </div>
              <select
                onChange={handleType}
                value={type}
                className={classes.inputCustom}>
                <option value="">{t("Choose Type")}</option>
                {typeArr.map((type, i) => (
                  <option value={type} key={i}>
                    {" "}
                    {type}
                  </option>
                ))}
              </select>
            </div>  
          </div>
        </div>
      </div>
      <div className="col-lg-6">
        <div className={classes.formCard}>
          <div className={classes.formGrid}>
            <div className={classes.formCol}>
              <label htmlFor="">{t("Amount Type")}</label>
              <div className={classes.iconInput}>
                <AmoutIcon />
              </div>
              <select
                onChange={handleAmountType}
                value={amount_Type}  
                className={classes.inputCustom}>
                <option value="">{t("Choose Amount Type")}</option>
                {amountType.map((amountype, i) => (
                  <option key={i} value={amountype}>
                    {amountype}
                  </option>
                ))}
              </select>
            </div>

            {!data ? (
              <div>no data available </div>
            ) : (
              <div className={classes.formCol}>
                <label htmlFor=""> {t("Company")}</label>
                <div className={classes.iconInput}>
                  <Company />
                </div>
                <select
                  type="text"
                 
                  onChange={handleSelectedIdChange}
                  className={classes.inputCustom}>
                  <option selected>{t("Choose Company")}</option>
                  {comapines.map((company) => (
                    <option
                      key={company.id}
                      id={company.id}
                      value={company.name}>
                      {company.name}
                    </option>
                  ))}
                </select>
              </div>
            )}

            <div className={classes.formCol}>
              <label
                htmlFor=""
                className={
                  active ? `${classes.active}` : `${classes.disActive}`
                }>
                {" "}
                {active == 1 ? " نشط" : "غير نشط"}{" "}
              </label>

              <label class="switch">
                <input
                  type="checkbox"
                  onChange={handleActiveChange}
                  checked={active}
                />
                <span class="slider round"></span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddSalary;
